module.exports = __webpack_public_path__ + "img/16.a8a947d3.jpg";